// @ts-ignore
const authInitState = JSON.parse(localStorage.getItem('auth')) || {
  isLoggedIn: false,
  user: {}
}

export { authInitState }
